export default "__VITE_ASSET__ClIqDVZ9__"